/*
 * @Desc:
 * @Author: wanglidong 王立冬
 * @Date: 2023-05-19 11:00:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-05-29 16:27:54
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved.
 */
import Cookies from 'js-cookie'

const TokenKey = 'wisdomCampus-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 30 })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
